export const AlertTab = {
  Triggers: 'triggers',
  Routes: 'routes',
  Recipients: 'recipients',
} as const;

export type AlertTab = (typeof AlertTab)[keyof typeof AlertTab];

export const TABS: readonly AlertTab[] = [
  AlertTab.Triggers,
  AlertTab.Routes,
  AlertTab.Recipients,
];
